import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";

import { PrimaryButton, PrimaryButtonOutlined } from "@components/Button";
import Dialog from "@components/Dialog";
import Div from "@components/Div";
import { H3 } from "@components/Heading";
import { Text } from "@components/Text";

const ProvideConsentQuestionDialog = ({ onClose, onSubmit }) => {
  const { messages } = useIntl();
  return (
    <Dialog
      visible
      draggable={false}
      onHide={onClose}
      m={[3, 3, "auto"]}
      width={[1, 1, "450px"]}
    >
      <Div display="flex" flexDirection="column" gridGap="20px">
        <Div
          display="flex"
          flexDirection="column"
          gridGap="15px"
          alignItems="center"
        >
          <H3>{messages.title_provide_consent_question}</H3>

          <Text textAlign="center">
            {messages.description_provide_consent_question}
          </Text>
        </Div>

        <Div
          display="flex"
          flexDirection={["column", "column", "row"]}
          gridGap="24px"
          alignItems={["stretch", "stretch", "center"]}
          justifyContent="center"
        >
          <PrimaryButtonOutlined
            label={messages.label_cancel}
            onClick={onClose}
          />

          <PrimaryButton
            label={messages.consent_title_share}
            onClick={onSubmit}
          />
        </Div>
      </Div>
    </Dialog>
  );
};

ProvideConsentQuestionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default ProvideConsentQuestionDialog;
